import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixVolumeUpIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M12.8726 3.97301C12.8724 3.81604 12.8257 3.66266 12.7384 3.53223C12.6511 3.40179 12.5271 3.30014 12.382 3.2401C12.237 3.18006 12.0774 3.16433 11.9235 3.19489C11.7695 3.22545 11.6281 3.30093 11.517 3.41181L7.7035 7.22413C7.55633 7.37218 7.38125 7.48955 7.18839 7.56944C6.99553 7.64933 6.78873 7.69016 6.57998 7.68954H3.85737C3.5585 7.68954 3.27187 7.80827 3.06053 8.01961C2.8492 8.23094 2.73047 8.51758 2.73047 8.81645V15.5779C2.73047 15.8768 2.8492 16.1634 3.06053 16.3747C3.27187 16.5861 3.5585 16.7048 3.85737 16.7048H6.57998C6.78873 16.7042 6.99553 16.745 7.18839 16.8249C7.38125 16.9048 7.55633 17.0222 7.7035 17.1702L11.5158 20.9837C11.6269 21.095 11.7686 21.1708 11.9229 21.2016C12.0771 21.2323 12.237 21.2166 12.3823 21.1564C12.5276 21.0961 12.6518 20.9941 12.7391 20.8633C12.8264 20.7324 12.8728 20.5786 12.8726 20.4213V3.97301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.1855 8.8125C16.917 9.78782 17.3125 10.9741 17.3125 12.1932C17.3125 13.4124 16.917 14.5986 16.1855 15.5739"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.2988 19.3667C19.2406 18.4249 19.9877 17.3068 20.4974 16.0763C21.0071 14.8458 21.2694 13.527 21.2694 12.1951C21.2694 10.8632 21.0071 9.54431 20.4974 8.3138C19.9877 7.08329 19.2406 5.96523 18.2988 5.02344"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
